import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import {
  getCategory,
  getSubCategory,
  create_product_master,
  updateProductMaster,
  getRawMaterials,
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

export const EditProductMaster = ({
  showModal,
  setShowModal,
  fetchProducts,
  selectedProduct,
  AddorEdit,
  setCurrentPage,
}) => {
  const { showLoader, hideLoader, shopItem, UserItem, warehouse } =
    useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    title: "",
    package_qty: "",
    cat_id: "",
    subcat_id: "",
    box_barcode: "",
    product_code: "",
    unit: "",
    box_qty: "",
    box_sales: "",
    reorder_point: "",
    status: "1",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
  });

  const [Category, setCategory] = useState([]);
  const [SubCategory, setSubCategory] = useState([]);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [showIngredients, setShowIngredients] = useState(true);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
    fetchRawMaterials();

    if (selectedProduct) {
      setFormData({
        title: selectedProduct?.title || "",
        package_qty: selectedProduct?.package_qty || "",
        cat_id: selectedProduct?.cat_id || "",
        box_qty: selectedProduct?.box_qty || "",
        sales_price: selectedProduct?.sales_price || "",
        box_barcode: selectedProduct?.box_barcode || "",
        product_code: selectedProduct?.product_code || "",
        box_sales: selectedProduct?.box_sales || "",
        subcat_id: selectedProduct?.subcat_id || "",
        reorder_point: selectedProduct?.reorder_point || "",
        unit: selectedProduct?.unit || "",
        status: selectedProduct?.status?.toString() || "",
        created_by: UserItem?.user_id || "0",
      });


      try {
        if (selectedProduct.ingridents) {
          const ingredients = JSON.parse(selectedProduct.ingridents);
          if (ingredients && ingredients.length > 0) {
            setIngredientsList(ingredients);
            setShowIngredients(true);
          }
        }
      } catch (error) {
        console.error("Error parsing ingredients:", error);
        setIngredientsList([]);
      }
    } else {
      resetForm();
    }
  }, [selectedProduct]);

  const fetchCategory = async () => {
    try {
      const response = await getCategory();
      if (response.data.data) {
        setCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getSubCategory();
      if (response.data.data) {
        setSubCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    }
  };


  const fetchRawMaterials = async () => {
    try {
      const params = {
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
        // ware_id: warehouse?.id || "1", // default warehouse ID
      };

      const response = await getRawMaterials(params);

      if (response.data && response.data.data) {
        setRawMaterialList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };


  const handleIngredientChange = (index, field, value) => {
    const updatedIngredients = [...ingredientsList];
    updatedIngredients[index][field] = value;
    setIngredientsList(updatedIngredients);
  };

  const addIngredient = () => {
    setIngredientsList([
      ...ingredientsList,
      { id: "", qty: "", unit: "grams" }
    ]);
  };

  const removeIngredient = (index) => {
    const updatedIngredients = [...ingredientsList];
    updatedIngredients.splice(index, 1);
    setIngredientsList(updatedIngredients);
  };


  const validateIngredients = () => {
    if (showIngredients && ingredientsList.length === 0) {
      toast.error("At least one ingredient is required when ingredients section is enabled");
      return false;
    }

    if (showIngredients) {
      for (let i = 0; i < ingredientsList.length; i++) {
        const ing = ingredientsList[i];
        if (!ing.id) {
          toast.error(`Please select raw material for ingredient #${i + 1}`);
          return false;
        }
      }


      const uniqueIngredientIds = new Set();
      for (let i = 0; i < ingredientsList.length; i++) {
        if (uniqueIngredientIds.has(ingredientsList[i].id)) {
          toast.error("Duplicate ingredients are not allowed");
          return false;
        }
        uniqueIngredientIds.add(ingredientsList[i].id);
      }
    }

    return true;
  };


  const getAvailableRawMaterials = (currentIndex) => {
    const selectedIds = ingredientsList
      .map((ing, idx) => idx !== currentIndex ? ing.id : null)
      .filter(id => id);

    return rawMaterialList.filter(rm => !selectedIds.includes(String(rm.id)));
    // return rawMaterialList.filter(rm => !selectedIds.includes(String(rm.id)) && String(rm.type) !== "1");
  };


  const getRawMaterialName = (id) => {
    const material = rawMaterialList.find(rm => String(rm.id) === String(id));
    return material ? material.title : 'Unknown Material';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    const validationErrors = {};
    if (!formData.title) validationErrors.title = "Product title is required.";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }


    if (!validateIngredients()) {
      hideLoader();
      return;
    }

    if (!validateForm()) {
      hideLoader();
      return;
    }

    try {

      const submitData = {
        ...formData,
        ingridents: showIngredients ? JSON.stringify(ingredientsList) : "[]"
      };

      console.log("Submitting data:", submitData);

      if (AddorEdit) {
        await create_product_master(submitData);
        toast.success("Product added successfully");
      } else {
        await updateProductMaster(selectedProduct?.product_id, submitData);
        toast.success("Product updated successfully");
      }
      setCurrentPage(1);
      fetchProducts();
      handleCancel();
    } catch (error) {
      console.error("Error Product Master data:", error);
      toast.error(error?.response?.data?.message || "Error saving product");
    } finally {
      hideLoader();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setFormData({
      title: "",
      package_qty: "",
      cat_id: "",
      subcat_id: "",
      sales_price: "",
      box_qty: "",
      box_sales: "",
      product_code: "",
      box_barcode: "",
      reorder_point: "",
      status: "1",
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
      // ware_id: shopItem?.ware_id || "1",
    });
    setIngredientsList([]);
    setShowIngredients(true);
    setErrors({});
  };

  const handleCancel = () => {
    setShowModal(false);
    resetForm();
  };


  const filteredSubcategories = SubCategory.filter(
    (sub) => sub.category_id === parseInt(formData.cat_id)
  );


  const validateForm = () => {
    const totalIngredientsQty = ingredientsList.reduce(
      (sum, ing) => sum + (Number(ing.qty) || 0),
      0
    );

    if (totalIngredientsQty > 1000) {

      const ok = window.confirm(
        `Total quantity = ${totalIngredientsQty}g exceeds the allowed limit (max 1000g).\n\nAre you sure you want to continue?`
      );

      if (!ok) {
        return false;
      }

      toast.info(
        `Total qty = ${totalIngredientsQty}g (max allowed = 1000g)`
      );

      return true;
    }

    return true;
  };



  const totalIngredientsQty = ingredientsList.reduce(
    (sum, ing) => sum + (Number(ing.qty) || 0),
    0
  );


  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {selectedProduct ? "Edit Product" : "Add Product"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit} className="row g-3">

                  {/* Category Dropdown */}
                  <div className="col-md-6">
                    <label>Category</label>
                    <select
                      name="cat_id"
                      value={formData.cat_id}
                      onChange={handleChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Category</option>
                      {Category?.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.Categories}
                        </option>
                      ))}
                    </select>
                    {errors.cat_id && (
                      <small className="text-danger">{errors.cat_id}</small>
                    )}
                  </div>

                  {/* SubCategory Dropdown */}
                  {/* <div className="col-md-6">
                    <label>Sub Category</label>
                    <select
                      name="subcat_id"
                      value={formData.subcat_id}
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Subcategory</option>
                      {filteredSubcategories?.map((sub) => (
                        <option key={sub.subcategory_id} value={sub.subcategory_id}>
                          {sub.subcategory_name}
                        </option>
                      ))}
                    </select>
                    {errors.subcat_id && (
                      <small className="text-danger">{errors.subcat_id}</small>
                    )}
                  </div> */}

                  {/* Product Title */}
                  <div className="col-md-6">
                    <label>Title <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                      className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                      required
                    />
                    {errors.title && (
                      <div className="invalid-feedback">{errors.title}</div>
                    )}
                  </div>


                  {/* Ingredients Section */}
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="d-flex justify-content-between align-items-center">
                          <h6 className="mb-0">Product Ingredients(1 Kg Limit)</h6>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={addIngredient}
                          // disabled={totalIngredientsQty >= 1000}

                          >
                            <i className="bi bi-plus"></i> Add Ingredient
                          </button>
                        </div>
                      </div>
                      <div className="card-body">
                        {ingredientsList.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-bordered table-sm">
                              <thead>
                                <tr>
                                  <th>Raw Material <span className="text-danger">*</span></th>
                                  <th width="120">Quantity(Grams)</th>
                                  <th width="120">Unit</th>
                                  <th width="80">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ingredientsList.map((ing, index) => (
                                  <tr key={index}>
                                    <td>
                                      <select
                                        value={ing.id}
                                        onChange={(e) => {
                                          const raw = rawMaterialList.find(
                                            (rm) => String(rm.id) === String(e.target.value)
                                          );
                                          if (raw) {
                                            handleIngredientChange(index, "id", raw.id);
                                            // Optionally set defaults
                                            if (raw.default_qty && !ing.qty) {
                                              handleIngredientChange(index, "qty", raw.default_qty);
                                            }
                                          }
                                        }}
                                        className="form-control form-control-sm"
                                        required
                                      >
                                        <option value="">Select Raw Material</option>
                                        {getAvailableRawMaterials(index).map((rm) => (
                                          <option key={rm.id} value={rm.id}>
                                            {rm.title}
                                          </option>
                                        ))}
                                        {/* Show currently selected item even if it would be filtered out */}
                                        {ing.id && !getAvailableRawMaterials(index).find(rm => String(rm.id) === String(ing.id)) && (
                                          <option key={ing.id} value={ing.id}>
                                            {getRawMaterialName(ing.id)}
                                          </option>
                                        )}
                                      </select>
                                    </td>

                                    {/* <td>
                                    <input
                                      type="number"
                                      placeholder="Qty"
                                      value={ing.qty || ""} 
                                      onChange={(e) => {
                                        const val = Number(e.target.value);
                                        if (val <= 1000) {
                                          handleIngredientChange(index, "qty", val);
                                        } else {
                                          toast.error("Max allowed is 1000 grams");
                                        }
                                      }}
                                      min="0"
                                      max="1000"
                                      className="form-control form-control-sm"
                                    />
                                    </td> */}
                                    <td>
                                      <input
                                        type="number"
                                        placeholder="Qty"
                                        value={ing.qty || ""}
                                        onChange={(e) => {
                                          let val = e.target.value;

                                          // Case 1: user clears input
                                          if (val === "" || val === null) {
                                            handleIngredientChange(index, "qty", "");
                                            return;
                                          }

                                          val = Number(val);
                                          const min = 0;
                                          const max = 999;

                                          // Case 2: value out of range
                                          if (val < min || val > max) {

                                            const ok = window.confirm(
                                              `Qty ${val}g is outside allowed range (${min}-${max}g).\nAre you sure you want to continue?`
                                            );

                                            if (ok) {
                                              toast.info(`Qty ${val}g is outside allowed range (${min}-${max}g)`);
                                              handleIngredientChange(index, "qty", val);
                                            } else {
                                              e.target.value = ing.qty || "";
                                            }

                                          } else {
                                            handleIngredientChange(index, "qty", val);
                                          }
                                        }}
                                        className="form-control form-control-sm"
                                        required
                                      />

                                    </td>



                                    <td>
                                      <select
                                        value={ing.unit || ""}
                                        onChange={(e) => handleIngredientChange(index, "unit", e.target.value)}
                                        className="form-control form-control-sm"
                                        required
                                      >
                                        <option value="">Select Unit</option>
                                        <option value="grams">Grams</option>
                                        {/* <option value="kg">Kilograms</option>
                                          <option value="liters">Liters</option>
                                          <option value="ml">Milliliters</option>
                                          <option value="pieces">Pieces</option> */}
                                      </select>
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={() => removeIngredient(index)}
                                        title="Remove ingredient"
                                      >
                                        <i className="bi bi-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="alert alert-warning">
                            No ingredients added yet. Click "Add Ingredient" to start.
                          </div>
                        )}

                        {/* Ingredients Summary */}
                        {ingredientsList.length > 0 && (
                          <div className="alert alert-info mt-3">
                            <div className="d-flex justify-content-between">
                              <span>Total Ingredients:</span>
                              <strong>{ingredientsList.length} item(s)</strong>
                            </div>
                            <div className="d-flex justify-content-between">
                              <span>Total Qty:</span>
                              <strong>
                                {totalIngredientsQty >= 1000
                                  ? `${(totalIngredientsQty / 1000).toFixed(0)} kg`
                                  : `${totalIngredientsQty} grams`}
                              </strong>
                            </div>
                          </div>
                        )}


                      </div>
                    </div>
                  </div>


                  {/* Form Buttons */}
                  <div className="col-12 text-end mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => handleCancel()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-success">
                      <i className="bi bi-check-circle me-1"></i>
                      {selectedProduct ? "Update Product" : "Add Product"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
